const SiteMenu = () => {
  const onClick = (evt) => {
    trigger.classList.toggle('close-menu');
    menu.classList.toggle('transition-menu');
  };

  const menu = document.getElementById('site-menu');
  const trigger = document.getElementById('show-site-menu');
  trigger.addEventListener('click', onClick);
};

export default SiteMenu;
